import { QuestionBase } from './question-base';
import { OptionQuestion } from './question-option';

export class CheckboxQuestion extends QuestionBase<string> {
    controlType = 'checkbox';
    options: OptionQuestion[] = [];

    constructor(options: {} = {}) {
        super(options);
        this.options = options['options'] || [];
    }
}
